<template>
  <div class="news-course-detail">
        <headerBlack-view></headerBlack-view>
        <!-- <newsHeader :page="'优秀课程'"></newsHeader> -->
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: `${breadcrumb.path}` }" v-if="breadcrumb.name">{{breadcrumb.name}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="breadcrumb.name">课程详情</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <breadCrumb></breadCrumb> -->
        <div class="news-course-detail-wrapper main">
            <div class="course-detail-top flex-layout">
                <img :src="downloadURL + courseInfo.cover" alt="" class="cover">
                <div class="course-basic-info flex-between">
                    <div class="basic-info-left flex-column-between">
                        <div>
                            <h4 class="f20 color-black course-title">{{courseInfo.name}}</h4>
                            <p class="f12 color-grey">
                                <span class="time">{{handleTime(courseInfo.timeScope)}}</span> 
                                <span>{{courseInfo.subject ? courseInfo.subject.name : '无' }}</span>
                            </p>
                        </div>
                        <div class="teacher">
                            <img :src="downloadURL + courseInfo.teacherInfo.avatar" alt="" class="avatar" :onerror="defualtImg.avatar">
                            <span>{{courseInfo.teacherInfo.name || '无' }}</span>
                        </div>
                    </div>
                </div>
                <div class="course-lecturer flex-column-center">
                    <button @click.prevent="tryToLive()" class="csp">
                        试看
                    </button>
                    <span class="f12 color-grey">21人看过</span>
                </div>
            </div>
            <div class="course-detail-bottom flex-between">
                <div class="introduce-part">
                    <ul class="introduce-tabs flex-layout">
                       <li  :class="{'active':activeTab == index}" 
                            v-for="(item,index) in tabs" 
                            :key="index"
                            @click="changePart(item,index)">
                            {{item}}
                        </li> 
                    </ul>
                    <div class="course-directory" v-if="!isActive">
                    <div class="course-teacher-introduce">
                        <h4 class="f20">课程简介</h4>
                        <div class="box flex-layout">
                            <div class="box-in">
                                <p>{{courseInfo.courseExplain}}</p>
                            </div>
                        </div>
                        <h4 class="f20">授课教师</h4>
                        <div class="box flex-layout">
                            <img :src="downloadURL + courseInfo.teacherInfo.avatar" alt="" :onerror="defualtImg.avatarColumn">
                            <div class="box-in">
                                <h5 class="f20 color-black">
                                    {{courseInfo.teacherInfo.name}}
                                    <span>{{courseInfo.teacherInfo.title}}</span>
                                </h5>
                                <p>{{courseInfo.teacherInfo.introduce}}</p>
                            </div>
                        </div>
                    </div>

                    </div>
                    <div class="course-introduce" v-else>
                        <ul class="course-list" v-if="lessonList.length > 0 && lessonList">
                            <li v-for="(item,index) in lessonList"
                                :key="index"
                                class="flex-align-between">
                                <h4 class="wes">{{item.name}}</h4>
                                 <div>
                                    <span class="time">{{dayjs(item.lessonsBeginTime*1000).format('YYYY-MM-DD HH:mm')}}</span>
                                    <button class="csp" @click.prevent="LessonToLive(item)" v-if="!index">试看</button>
                                    <p v-else></p>
                                </div>
                            </li>
                        </ul>

                        <div class="nothing-box flex-align" v-else>
                          <div class="nothing-wrap">
                            <img src="@/assets/wisdom/nothing.png" alt="">
                            <p>暂无内容</p>
                          </div>
                        </div>
                    </div>
                        
                </div>
                
                <div class="side-navbar">
                    <div class="title f20"> 
                        <i class="el-icon-s-management"></i>
                        推荐课程
                    </div>
                    <ul v-if="recommendList.length > 0  && recommendList">
                        <li v-for="(item, index) in recommendList" 
                            :key="index"
                            class="csp"
                            @click="toNews(item)">
                            <h5 class="wes">
                                <i :class="`num-${index+1}`">{{index+1}}</i> 
                            {{item.name}}
                            </h5>
                            <div class="summary flex-align-between">
                                <div class="">
                                    <img :src="downloadURL + item.avatar" alt="" class="recommend-avatar" :onerror="defualtAvatar">
                                    <span>{{item.teacherName}}</span>
                                </div>
                                <span class="tr">{{item.views || 0}}人看过</span>
                            </div>
                        </li>
                    </ul>

                    <div class="nothing-box flex-align" v-else>
                        <div class="nothing-wrap">
                          <img src="@/assets/wisdom/nothing.png" alt="">
                          <p>暂无内容</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-view></footer-view>
  </div>
</template>

<script>
export default {
    data() {
        return {
            courseInfo:{ //课程信息
                subject:{
                    name:'',
                    avatar:'',
                },
                teacherInfo:{
                    name:'',
                    avatar:'',
                }
            },
            isActive:0,
            recommendList:[
                {
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },
                {
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },{
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },
                {
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },
                {
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },{
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                },
                {
                    title:'标题标题',
                    avatar:'',
                    teacher:'王艳伟',
                    views:20,
                }
            ],
            tabs:['课程介绍','课程大纲'],
            activeTab:0,
            lessonList:[
                {
                    name:'课程名称课程名称',
                    time:'2020.07.19 12:32',
                },
                {
                    name:'课程名称课程名称',
                    time:'2020.07.19 12:32',
                },
                {
                    name:'课程名称课程名称',
                    time:'2020.07.19 12:32',
                },
                
            ],
            defualtAvatar:'this.src="' + require("@/assets/wisdom/men.png") + '"',
            defualtAvatarColumn:'this.src="' + require("@/assets/wisdom/man.png") + '"',
            proId:0,
            
        }
    },
    computed:{
        // 根据性别选择默认头像， 男性0 女性1 未知2  （男性与未知都默认用男性头像）
        // avatar  圆形小头像 ， avatarColumn 长方形大头像
        defualtImg() {
            if(this.courseInfo.teacherInfo.sex == 1) {
                return  {
                            avatar:'this.src="' + require("@/assets/wisdom/women.png") + '"',
                            avatarColumn:'this.src="' + require("@/assets/wisdom/woman.png") + '"',
                        }
            } else {
                return {
                            avatar:'this.src="' + require("@/assets/wisdom/men.png") + '"',
                            avatarColumn:'this.src="' + require("@/assets/wisdom/man.png") + '"',
                        }
            }
        },
        breadcrumb() {
            let map = {
                90 : {
                    name:'首师智研',
                    path:'/yunqiao/wisdom'
                },
                109 : {
                    name:'1+X后勤管理与职业教育系统',
                    path:'/yunqiao/logistics'
                },
                110 : {
                    name:'内蒙古自治区三科统编教材中部四盟市教师专项培训',
                    path:'/yunqiao/innerMongolia'
                }
            }
            return map[this.proId] ? map[this.proId] : {name:'',path:''}
        }
    },
    methods: {
        // tab切换
        changePart(item,index) {
            this.activeTab = this.isActive = index;
        },
        // 试看 去看课程
        tryToLive() {
            if(!this.courseInfo.latestLesson) return
            sessionStorage.setItem('videoUrl',this.courseInfo.latestLesson.videoUrl);
            let beginTime = this.dayjs(this.courseInfo.latestLesson.lessonsBeginTime*1000).format('YYYY-MM-DD HH:mm:ss') || ''
            let endTime = this.dayjs(this.courseInfo.latestLesson.lessonsEndTime*1000).format('YYYY-MM-DD HH:mm:ss') || ''
            sessionStorage.setItem('videoTime',`${beginTime}-${endTime}`)
            this.$router.push({
                path:`/yunqiao/live/${this.courseInfo.latestLesson.id}`,
                query:{
                    activeId:this.$route.params.id
                }
            })
            // sessionStorage.setItem('videoUrl',this.courseInfo.latestLesson)
        },
        // 课节去看视频
        LessonToLive(item) {
            console.log(item);
            if(!item.videoUrl) return;
            this.$router.push({
                path:`/yunqiao/live/${this.$route.params.id}`,
                query:{
                    activeId:this.$route.params.id
                }
            })
            sessionStorage.setItem('videoUrl',item.videoUrl);
            let beginTime = this.dayjs(item.lessonsBeginTime*1000).format('YYYY-MM-DD HH:mm:ss') || ''
            let endTime = this.dayjs(item.lessonsEndTime*1000).format('YYYY-MM-DD HH:mm:ss') || ''
            sessionStorage.setItem('videoTime',`${beginTime}-${endTime}`)
        },
        // 去新闻详情页
        toNews(item) {
            console.log(item.name);
            this.$router.push(`/yunqiao/subject/detail/${item.id}`)
            this.init();
        },
        handleTime(time){
            if(!time) return 
            if(time.indexOf('~') != -1) return time
            return this.dayjs(this.courseInfo.timeScope).format('YYYY-MM-DD hh:mm')
        },
        // 获取课程信息
        async getCourseInfo() {
            let resData = await Api.Wisdom.getCourseInfo(this.$route.params.id);
            console.log(resData);
            if(!resData.data) return
            this.courseInfo = resData.data;
            

        },
        // 获取课节信息
        async getLessonList() {
            let resData = await Api.Wisdom.getLessonList(this.$route.params.id);
            // console.log(resData);
            if(!resData.data) return
            this.lessonList = resData.data;
        },
        // 获取推荐课程
        async getRecommend() {
            let params = {
                projectId :Number(sessionStorage.getItem('projectID'))
            }
            let  resData = await Api.Wisdom.getRecommend(params);
            // console.log(resData);
            if(!resData.data) return
            this.recommendList = resData.data
        },
        // 页面初始化
        init() {
            this.proId = Number(sessionStorage.getItem('projectID'))
            this.getCourseInfo();
            this.getLessonList();
            this.getRecommend();
        }
    },
    mounted() {
        scroll(0,0)
        this.init();
    },
}
</script>

<style lang="less">
    @import "./less/news_course_detail.less";
</style>